/**
 * product-inventory: the stock line under the sizes (L41,
 * snippets/product-inventory.liquid). Liquid writes the sentence for every
 * variant that has few left ({"<variant id>": "Nog 3 op voorraad in maat L"});
 * this element shows the sentence of the chosen variant and hides itself for
 * every other variant, or when no variant is chosen.
 */
if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    connectedCallback() {
      this.lines = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.text = this.querySelector('[data-inventory-text]');
      this.picker = this.closest('.product-info')?.querySelector('variant-picker');
      this.onVariantChange = (event) => this.show(event.detail.variant);
      this.picker?.addEventListener('on:variant:change', this.onVariantChange);
    }

    disconnectedCallback() {
      this.picker?.removeEventListener('on:variant:change', this.onVariantChange);
    }

    /**
     * Shows the line of the chosen variant, or nothing.
     * @param {?object} variant - The chosen variant, null when the choice is incomplete.
     */
    show(variant) {
      const line = (variant && this.lines[variant.id]) || '';
      this.text.textContent = line;
      this.hidden = !line;
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
